$( document ).ready(function() {
  
  var ww = $(window).width();
  function menuChange() {
    ww = $(window).width();
    if(ww < 820){
      $("#info-footer").appendTo("nav#menu");
      $("#info-container, #legal-container").appendTo("#menu-content-mobile");
    } else {
      $("#legal-container, #info-container, #info-footer").insertAfter("#background-blur");
    }
  }
  if(ww < 820){
    $("#info-footer").appendTo("nav#menu");
    $("#info-container, #legal-container").appendTo("#menu-content-mobile");
  }
  $( window ).on( "resize", function() {
    menuChange();
  });

  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  appHeight();

  // Ensure body scroll isn't accidentally locked (e.g., cached page restore on iOS)
  function unlockBodyIfNoOverlay() {
    const $body = $('body');
    const hasOverlay = $body.is('.show-menu, .show-info, .show-legal, .show-livestream, .minicart-open');
    if (!hasOverlay) {
      $body.removeClass('no-scroll show-menu');
      $('html').removeClass('show-menu');
    }
  }
  unlockBodyIfNoOverlay();
  window.addEventListener('pageshow', unlockBodyIfNoOverlay);

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  $( window ).on( "resize", function() {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  });

  // MORE/LESS
  const grid = $('#index-grid');

  let gridClasses;
  let currentGridClassIndex;
  
  // Check if there's a swiper on the homepage
  const hasHomepageSwiper = document.querySelector('#look-swiper-homepage');
  
  // Only set up grid functionality if there's no swiper
  if (!hasHomepageSwiper) {
    // Definir las clases de la cuadrícula para cada breakpoint
    const gridClassesMobile = ['grid-1', 'grid-2', 'grid-3', 'grid-4']; // <= 820px
    const gridClassesTablet = ['grid-1', 'grid-2', 'grid-3', 'grid-4', 'grid-5']; // > 820px y <= 1196px
    const gridClassesDesktop = ['grid-1', 'grid-2', 'grid-3', 'grid-4', 'grid-5', 'grid-6']; // > 1196px y <= 1440px
    const gridClassesLargeDesktop = ['grid-1', 'grid-2', 'grid-3', 'grid-4', 'grid-5', 'grid-6', 'grid-7']; // > 1440px
    
    // Función para ajustar el grid basado en el tamaño de la pantalla
    const adjustGrid = () => {
        const screenWidth = window.innerWidth;
    
        // Determinar qué conjunto de clases usar basado en el ancho de la pantalla
        if (screenWidth <= 820) {
            gridClasses = gridClassesMobile;
            currentGridClassIndex = gridClasses.indexOf('grid-3');
        } else if (screenWidth <= 1440) {
            gridClasses = gridClassesTablet;
            currentGridClassIndex = gridClasses.indexOf('grid-4');
        } else if (screenWidth <= 1800) {
            gridClasses = gridClassesDesktop;
            currentGridClassIndex = gridClasses.indexOf('grid-5');
        } else {
            gridClasses = gridClassesLargeDesktop;
            currentGridClassIndex = gridClasses.indexOf('grid-6');
        }
    
        // Remover todas las clases posibles y agregar la nueva clase
        grid.removeClass(gridClassesMobile.concat(gridClassesTablet, gridClassesDesktop, gridClassesLargeDesktop).join(' '));
        grid.addClass(gridClasses[currentGridClassIndex]);
    
        // Actualizar el estado de los botones
        updateButtonsState();
    };
    
    // Actualizar el estado de los botones "More" y "Less"
    const updateButtonsState = () => {
        $('.more-trigger').prop('disabled', currentGridClassIndex === gridClasses.length - 1);
        $('.less-trigger').prop('disabled', currentGridClassIndex === 0);
    };
    
    // Inicializar el estado del grid y los botones
    adjustGrid();
    
    // Manejar clic en el botón "More"
    $('.more-trigger').on('click', () => {
        if (currentGridClassIndex < gridClasses.length - 1) {
            grid.removeClass(gridClasses[currentGridClassIndex]);
            currentGridClassIndex++;
            grid.addClass(gridClasses[currentGridClassIndex]);
            updateButtonsState();
        }
    });
    
    // Manejar clic en el botón "Less"
    $('.less-trigger').on('click', () => {
        if (currentGridClassIndex > 0) {
            grid.removeClass(gridClasses[currentGridClassIndex]);
            currentGridClassIndex--;
            grid.addClass(gridClasses[currentGridClassIndex]);
            updateButtonsState();
        }
    });
    
    // Escuchar el evento de resize para reajustar el grid
    $(window).on('resize', () => {
        adjustGrid();
    });
  }
  
  


    $('.social-media-column .footer-link').on('click', function(event) {
        event.preventDefault(); // Previene el comportamiento por defecto del enlace
        $("#info-container").scrollTop(0); // Resetea la posición del scroll a 0
    });


  // PAGINATION CLICK TOTAL
  $('.swiper-pagination-total, .swiper-pagination .next-arrow').on('click', function() {
    $('.swiper-button-next').trigger('click');
  });

  // PAGINATION CLICK PREV
  $('.swiper-pagination-current, .swiper-pagination .prev-arrow').on('click', function() {
    $('.swiper-button-prev').trigger('click');
  });

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);


  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  // Mobile submenus (Categories / Collections) inside overlay menu
  function isMobile() { return window.innerWidth <= 820; }

  // Unified dropdown state management for mobile overlay
  // Resets the state of a specific dropdown toggle or all toggles if no selector provided
  function resetDropdownState(selector) {
    var $toggles = selector ? $(selector) : $('.mobile-menu-toggle');
    $toggles.removeClass('is-active').attr('aria-expanded', 'false');
  }

  // Update mobile dropdown trigger states based on visibility of their associated submenus
  function updateMobileDropdownTriggers() {
    $('.mobile-menu-toggle').each(function() {
      var $trigger = $(this);
      var menuId = $trigger.attr('data-menu');
      if (!menuId) return;

      var $submenu = $('#mobile-submenu-' + menuId);
      var isVisible = $submenu.length && $submenu.is(':visible');

      $trigger.toggleClass('is-active', isVisible);
      $trigger.attr('aria-expanded', isVisible ? 'true' : 'false');
    });
  }

  // Expose for inline snippet in shop-nav-mobile.liquid
  window.updateMobileDropdownTriggers = updateMobileDropdownTriggers;

  function closeOverlayMenu() {
    $('body').removeClass('show-menu show-info show-legal show-livestream no-scroll show-blur');
    $('html').removeClass('show-menu');
    $('#menu .menu-row .submenu').hide();
    // Reset all mobile menu toggles to inactive state
    resetDropdownState();
    $('#info-trigger span:first-child').show();
    $('#info-trigger span:last-child').hide();
  }

  $(document).on('click', '#menu .categories-menu-link, #menu .collections-menu-link', function(e){
    if (!isMobile()) return; // desktop: behave as normal link
    e.preventDefault();
    const row = $(this).closest('.menu-row');
    const submenu = row.find('.submenu');
    // Close any other open submenu
    $('#menu .menu-row .submenu').not(submenu).slideUp(200);
    submenu.slideToggle(200);
  });

  // When closing the overlay menu, collapse any open submenu
  $(document).on('click', '#info-trigger', function(){
    if (!$('body').hasClass('show-menu')) {
      $('#menu .menu-row .submenu').hide();
      resetDropdownState();
    }
    $('html').toggleClass('show-menu', $('body').hasClass('show-menu'));
  });

  // Ensure tapping real links inside the mobile overlay closes it before navigation
  $(document).on('click', '#menu a', function(e){
    var $link = $(this);
    // Keep menu open for internal overlay panels (info, legal, livestream, info-footer)
    var isOverlayLink =
      $link.hasClass('mobile-menu-toggle') ||
      $link.hasClass('info-menu-link') ||
      $link.hasClass('information-menu-link') ||
      $link.hasClass('livestream-menu-link') ||
      $link.hasClass('legal-link') ||
      $link.closest('#info-footer').length ||
      $link.is('[data-page]');

    if (isOverlayLink) {
      return;
    }
    closeOverlayMenu();
  });

  // On resize to desktop, ensure submenus are collapsed
  $(window).on('resize', function(){
    if (!isMobile()) {
      $('#menu .menu-row .submenu').hide();
      resetDropdownState();
    }
  });
 // NEW MENU TRIGGER
 $( "#info-trigger" ).click(function(e) {
  if($("body").is(".show-menu")) {
    console.log("CIERRA MENU");
    $("body").removeClass("show-info show-legal no-scroll show-blur show-menu show-livestream");
    $("html").removeClass("show-menu");
    $(".info-content, .legal-content").removeClass("show");
    $(".legal-title").removeClass("selected");
  } else if ($("body").is(".minicart-open")){
    console.log("CIERRA Minicart");
    $("body").removeClass("no-scroll show-blur show-menu minicart-open");
    $("html").removeClass("show-menu");
  } else if ($("body").is(".show-legal")){
    $("body").removeClass("show-legal no-scroll show-blur");
    $("html").removeClass("show-menu");
  } else {
    console.log("CIERRA algo");
    $("body").toggleClass("no-scroll show-blur show-menu");
    $("html").toggleClass("show-menu", $("body").hasClass("show-menu"));
    $("#info-trigger").children("span").toggle();
  } 
});

  // NEW MENU CART TRIGGER
  $("#cart-trigger" ).click(function(e) {
    $("body").removeClass("show-menu no-scroll show-blur");
  });

  // NEW MENU INFO
  $( ".info-menu-link" ).click(function(e) {
    e.preventDefault();
    $(".legal-title").removeClass("selected");
    $(".legal-content").removeClass("show");
    if($("body").is(".show-legal")) {
      $("body").removeClass("show-legal");
      $("body").removeClass("show-livestream");
      $("#contact").removeClass("show");
      $("body").addClass("show-info");
      $("#about-content").addClass("show");
      $("body").addClass("no-scroll show-blur");
    } else {
      $("body").removeClass("show-livestream");
      $("#contact").removeClass("show");
      $("body").addClass("show-info");
      $("#about-content").addClass("show");
      $("body").addClass("no-scroll show-blur");
    }
  });

  // INFORMATION menu should open the Legal/Information panel
  $( ".information-menu-link" ).click(function(e) {
    e.preventDefault();
    // Ensure only the Legal panel is shown
    $("body").removeClass("show-info show-livestream");
    $(".info-content").removeClass("show");
    $(".legal-content").removeClass("show");
    $(".legal-trigger").removeClass("selected");
    $(".legal-title").removeClass("selected");

    // Open Legal view and default to Shipping
    $("body").addClass("show-legal no-scroll show-blur");
    $("#shipping").addClass("show");
    $(".legal-trigger-shipping").addClass("selected");
    $(".legal-title-shipping").addClass("selected");
  });

  // PDP: "More information" should open the Legal container at Shipping
  $(document).on('click', '.more-info-link', function(e) {
    e.preventDefault();
    // Reset other states
    $("body").removeClass("show-info show-livestream");
    $(".info-content").removeClass("show");
    $(".legal-content").removeClass("show");
    $(".legal-trigger").removeClass("selected");
    $(".legal-title").removeClass("selected");

    // Open Legal view and default to Shipping
    $("body").addClass("show-legal no-scroll show-blur");
    $("#shipping").addClass("show");
    $(".legal-trigger-shipping").addClass("selected");
    $(".legal-title-shipping").addClass("selected");

    // On mobile, also show the menu overlay so the legal container inside it is visible
    if (window.innerWidth <= 820) {
      $("body").addClass("show-menu");
      $("html").addClass("show-menu");
      $('#info-trigger span:first-child').hide();
      $('#info-trigger span:last-child').show();
    }

    // Scroll panel to top
    $("#legal-container").scrollTop(0);
  });

  // NEW MENU LIVESTREAM
  $( ".livestream-menu-link" ).click(function(e) {
    e.preventDefault();
    $(".legal-title").removeClass("selected");
    $(".legal-content").removeClass("show");
    if($("body").is(".show-legal")) {
      $("body").removeClass("show-legal");
      $("body").removeClass("show-info");
      $("body").addClass("show-livestream");
      $("body").addClass("no-scroll show-blur");
    } else {
      $("body").removeClass("show-info");
      $("body").addClass("show-livestream");
      $("body").addClass("no-scroll show-blur");
    }
  });

// NEW MENU CONTACT - REMOVED TO OPEN CONTACT PAGE! 04.09.25
// $( ".contact-menu-link" ).click(function(e) {
//   e.preventDefault();
//   $(".legal-title").removeClass("selected");
//   $(".legal-content").removeClass("show");
//   if($("body").is(".show-legal")) {
//     $("body").removeClass("show-legal");
//     $("body").removeClass("show-livestream");
//     $(".info-content").removeClass("show");
//     $("body").addClass("show-info");
//     $("#contact").addClass("show");
//     $("body").addClass("no-scroll show-blur");
//   } else {
//     $("body").removeClass("show-livestream");
//     $(".info-content").removeClass("show");
//     $("body").addClass("show-info");
//     $("#contact").addClass("show");
//     $("body").addClass("no-scroll show-blur");
//   }
// }); 

 
  
  // TOGGLE MENU
  // $( "#info-trigger" ).click(function(e) {
  //   if($("body").is(".show-info")){
  //     $("body").removeClass("show-info no-scroll show-blur");
  //     $("#contact").removeClass("show");
  //     $("#about-content").addClass("show");
  //   } else if($("body").is(".show-legal ")) {
  //     $("body").removeClass("show-legal no-scroll");
  //     $("body").removeClass("show-blur no-scroll");
  //     $("#returns").removeClass("show");
  //     $(".legal-trigger-returns").removeClass("selected");
  //     $("#shipping").removeClass("show");
  //     $(".legal-trigger-shipping").removeClass("selected");
  //   } else if($("body").is(".minicart-open")) {
  //     $("body").removeClass("minicart-open no-scroll show-blur");
  //   }else if($("body").is(".show-livestream")) {
  //     $("body").removeClass("show-livestream no-scroll show-blur");
  //   }else {
  //     $("body").addClass("no-scroll show-blur show-info");
  //   }
  // });



  // Do not lock body scroll when adding to cart; minicart overlay already handles its own scroll state
  $( ".product-add" ).click(function(e) {
    $("body").removeClass("no-scroll");
  });
  $( "#cart-trigger" ).click(function(e) {
    if($("body").is(".show-info")){
      $("body").removeClass("show-info show-blur");
      $("#contact").removeClass("show");
      $("#about-content").addClass("show");
    } else if($("body").is(".show-legal")){
      $("body").removeClass("show-legal  show-blur");
      $("#returns").removeClass("show");
      $(".legal-trigger-returns").removeClass("selected");
      $("#shipping").removeClass("show");
      $(".legal-trigger-shipping").removeClass("selected");
    } else if($("body").is(".show-livestream")){
      $("body").removeClass("show-livestream");
    } else {
    }
  });
  $( ".returns" ).click(function(e) {
    $("body").addClass("show-legal no-scroll show-blur");
    $("#returns").addClass("show");
    $(".legal-trigger-shipping").removeClass("selected");
    $(".legal-trigger-returns").addClass("selected");
  });
  $( ".shipping" ).click(function(e) {
    $("body").addClass("show-legal no-scroll show-blur");
    $("#shipping").addClass("show");
    $(".legal-trigger-returns").removeClass("selected");
    $(".legal-trigger-shipping").addClass("selected");
    
  });

  $( ".footer-link" ).click(function(e) {
    e.preventDefault();
    var el = $(this);
    var handle = el.data("page"); handle = "#" + handle;
    console.log(handle);
    if($(handle).is(".show")){
      $(".info-content").removeClass("show");
      $("#about-content").addClass("show");
      $(".footer-link").removeClass("current");
    } else {
      $(".info-content").removeClass("show");
      $(handle).addClass("show");
      $(".footer-link").removeClass("current");
      el.addClass("current");
    }
  });

  $( ".legal-link, .legal-trigger" ).click(function(e) {
    e.preventDefault();
    var el = $(this);
    var handle = el.data("page");
    console.log(handle);
    $("body").removeClass("show-info").addClass("show-legal");
    $("body").removeClass("show-livestream");
    $(".info-content").removeClass("show");

    $(".legal-trigger").not(".legal-trigger[data-page='" + handle + "']").removeClass("selected");
    $(".legal-title").not(".legal-title[data-page='" + handle + "']").removeClass("selected");
    $(".legal-content").not(".legal-content#" + handle).removeClass("show");

    if($(".legal-trigger[data-page='" + handle + "']").is(".selected")){
      $(".legal-trigger[data-page='" + handle + "']").removeClass("selected");
      $(".legal-title[data-page='" + handle + "']").removeClass("selected");
      $(".legal-content#" + handle ).removeClass("show");
    } else {
      $(".legal-trigger[data-page='" + handle + "']").addClass("selected");
      $(".legal-title[data-page='" + handle + "']").addClass("selected");
      $(".legal-content#" + handle ).addClass("show");
    }
  });


  // TOGGLE MINICART
  $( "#mini-cart-close-mobile" ).click(function() {
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).removeClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  $( "#cart-trigger" ).click(function() {
    $( "#mini-cart" ).toggleClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).toggleClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container, #contact-container').slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });



  // FOOTER
  $( "#footer-credits-trigger" ).click(function() {
    $('#footer-credits').slideToggle(300);
  });
  
  // MENU
  $( "#about-trigger, #about-close" ).click(function() {
    $( "#about-trigger span" ).toggle();
    $('#about-container').appendTo("#header");
    $('#about-container').slideToggle(300);
    $('#newin-container, #collection-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
  });
  var hoverTimeoutShop;
  $("#shop-trigger, #shop-container").hover(
    function() {
      clearTimeout(hoverTimeoutShop);
      $("#shop-container").slideDown(300);
      $('#newin-container, #collection-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutShop = setTimeout(function() {
        $("#shop-container").slideUp(300);
      }, 200);
    }
  );
  
  var hoverTimeoutNewIn;
  $("#newin-trigger, #newin-container").hover(
    function() {
      clearTimeout(hoverTimeoutNewIn);
      $("#newin-container").slideDown(300);
      $('#shop-container, #collection-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutNewIn = setTimeout(function() {
        $("#newin-container").slideUp(300);
      }, 200);
    }
  );
  
  /*$("#collection-trigger").click(function() {
    $('#collection-container').slideToggle(300);
    $('#newin-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
  });*/
  var hoverTimeoutCollection;
  $("#collection-trigger, #collection-container").hover(
    function() {
      clearTimeout(hoverTimeoutCollection);
      $("#collection-container").slideDown(300);
      $('#newin-container, #shop-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutCollection = setTimeout(function() {
        $("#collection-container").slideUp(300);
      }, 200);
    }
  );
  
  $("#search-trigger-mobile").click(function() {
    if ($('#search-form').is(':visible')) {
        $(".nav-item-content").slideDown(300);
    } else {
        $(".nav-item-content, #about-container").slideUp(300);
    }
    $("#search-form").insertAfter($(this));
    $('#search-form').slideToggle(300);
    setTimeout(function(){
      $("input.search-input-text").focus();
    }, 400);
  });
  var hoverTimeoutSearch;
  var ww = $(window).width();
  $("#search-trigger, #search-form").hover(
    function() {
      clearTimeout(hoverTimeoutSearch);
      $('#search-form').slideDown(300);
      $('#newin-container, #collection-container, #shop-container, #contact-container, #about-container').slideUp(300);
      $( "#mini-cart" ).removeClass("active").slideUp(300);
      setTimeout(function(){
        $("input.search-input-text").focus();
      }, 400);
    },
    function() {
      hoverTimeoutSearch = setTimeout(function() {
        if(ww > 820){
          $("#search-form").slideUp(300);
        }
      }, 200);
    }
  );
  $("#search-close").click(function() {
    $('#search-form').slideUp(300);
  });


  
  
 

  // $( ".collection-link" ).hover(
  //   function() {
  //     var img = $(this).attr("data-img")
  //     if(img != ""){
  //       console.log("Contiene", img);
  //       $("<div class='hover-image-menu'><img src='" + img + "'></div>").appendTo( $(this).parent() );
  //     }
  //   }, function() {
  //     $(".hover-image-menu").remove();
  //   }
  // );

  $('.footer-link[href="/pages/about"]').click(function() {
    event.preventDefault();
    $("#about-container").appendTo("#header");
    $("#about-container").slideDown(300);
    $('#newin-container, #collection-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $("#mini-cart").removeClass("active").slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  $("#shop-label-mobile, #newin-label-mobile, #collection-label-mobile").click(function() {
    $(".nav-item-content").slideDown(300);
    $("#about-container, #search-form").slideUp(300);
  });

  $('#about-trigger-mobile').click(function() {
    event.preventDefault();
    if ($('#about-container').is(':visible')) {
        $(".nav-item-content").slideDown(300);
    } else {
        $(".nav-item-content, #search-form").slideUp(300);
    }
    $("#about-container").insertAfter($(this));
    $("#about-container").slideToggle(300);
  });

  var windowWidth = $(window).width();
  
  $('.footer-link[href="/pages/contact"], #contact-close').click(function() {
    event.preventDefault();
    if(windowWidth < 821){
      $("#contact-container").insertAfter($(this));
    }
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container').slideUp(300);
    $('#contact-container').slideToggle(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  // MENU MOBILE
  $("#menu-trigger-mobile").click(function() {
    $(this).children("span").toggle();
    $("#menu-mobile").slideToggle().toggleClass("active");
  });

  // LIVESTREAM
  $("#livestream").click(function() {
    $("body").addClass("no-scroll");
    $("body").addClass("livestream-home");
    $("body").toggleClass("show-blur").toggleClass("show-livestream");
  });
  $("#livestream-back, #livestream-exit").click(function() {
    $("body").removeClass("no-scroll");
    $("body").removeClass("livestream-home");
    $("body").removeClass("show-blur").removeClass("show-livestream");
    $( '#live-stream-container iframe' ).attr( 'src', $( '#live-stream-container iframe' ).attr('src'));
  });
  
  
  // HIGHLIGHT CHANGE IMAGE MOBILE
  $(".homepage-highlight-image").click(function() {
    event.preventDefault();
    var windowWidth = $(window).width(),
        href = $(this).parent().parent('.homepage-highlight-link').attr('href'),
        el = $(this),
        src = el.attr("src");
    if(windowWidth <= 820){
      el.parent().parent().parent().children(".homepage-highlight-mobile").children(".highlight-module").children(".homepage-highlight-image").attr("src", src);
    } else {
      window.location.href = href;
    }
  });

  // Removed custom horizontal scroll handlers; rely on native deltas only.

  
  if(windowWidth > 820){
    const featuredSwiper = new Swiper('.featured-swiper', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 15,
      mousewheel: {
        forceToAxis: true,
        sensitivity: .75,
        thresholdDelta: 50,
        thresholdTime: 50
      },
      freeMode: {
        enabled: true,
        sticky: false,
        minimumVelocity: 0.1,
        momentumRatio: 1
      },
      breakpoints: {
        820: {
          freeMode: {
            enabled: true,
            sticky: false,
            minimumVelocity: 0.1,
            momentumRatio: 5
          },
        }
      },
    });
  }
});



document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("scroll", function() {
    var footer = document.getElementById("footer");
    var projectsNav = document.body;
    var footerRect = footer.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    if (footerRect.top < viewportHeight && footerRect.bottom >= 0) {
      projectsNav.classList.add("hide");
    } else {
      projectsNav.classList.remove("hide");
    }
  });
});

